export enum NdsModalSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  BIG = 'big',
  XLARGE = 'xlarge',
}

export enum NdsModalBorder {
  HEADER_BOTTOM = 'headerBottom',
  BEFORE_CONTENT_TOP = 'beforeContentTop',
  BEFORE_CONTENT_BOTTOM = 'beforeContentBottom',
  CONTENT_TOP = 'contentTop',
  CONTENT_BOTTOM = 'contentBottom',
  AFTER_CONTENT_TOP = 'afterContentTop',
  AFTER_CONTENT_BOTTOM = 'afterContentBottom',
  FOOTER_TOP = 'footerBottom',
}

export enum NdsModalHeaderBackground {
  WHITE = 'white',
  WARNING = 'warning',
  SUCCESS = 'success',
  DANGER = 'danger',
}
